<span>Threat Retrospect uses fresh threat intelligence to scan existing user emails for newly discovered Indicators of Compromise (IoCs), and automatically removes any malicious messages.</span>

<div class="d-flex w-100 centralize" *ngIf="getConfigInProcess">
	<loader height="100" width="100" style="opacity: 0.8;"></loader>
</div>

<ng-container *ngIf="!getConfigInProcess">
	<div class="list-group list-group-flush settings-list-container animated fadeIn" *ngIf="config">
		<div class="list-group-item settings-list-item" *ngIf="!isFeatureEnabled">
			<div class="flex-row align-items-center bg-warning border border-warning gap-3 p-3 animated fadeIn" style="--bs-bg-opacity: .15; line-height: 1.7;">
				<i class="far fa-exclamation-circle text-warning p-3" style="font-size: 2.2rem;"></i>
				<div class="flex-column">
					<h5>Important Note:</h5>
					<span style="font-size: 0.9rem;">
							Your plan is not currently connected to a mail server integration with Office 365 or Google Workspace.<br/>The <b>Threat Retrospective feature will only function</b> once a mail server integration with Office 365 or Google Workspace is established.<br/>
							<a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.plan, dic.CONSTANTS.inboundPlanSettingsPageTabs.integrations]">Click here</a> to go to Inbound Integrations page.
						</span>
				</div>
			</div>
		</div>
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Enable</b>
				<span style="font-size: 0.9em;">Enable retroactive detection and removal of malicious emails based on updated IoCs.</span>
			</div>
			<div class="content-container">
				<toggle-switch-c id="enableRetrospect" class="d-inline-flex"
								 [(model)]="config.enabled"
								 [isDisabled]="updateConfigInProcess"
								 (change)="updateThreatRetrospectSettings(dic.CONSTANTS.threatRetrospectActions.enabled)"></toggle-switch-c>
			</div>
		</div>
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Notification email</b>
				<span style="font-size: 0.9em;">Send notification emails to inbound reviewers for actions taken by Threat Retrospect.</span>
			</div>
			<div class="content-container">
				<toggle-switch-c id="notifyRetrospectAdmin" class="d-inline-flex"
								 [(model)]="config.notify_admin"
								 [tooltip]="config.enabled ? null : 'Enable Threat Retrospect first'"
								 [isDisabled]="updateConfigInProcess || !config.enabled"
								 (change)="updateThreatRetrospectSettings(dic.CONSTANTS.threatRetrospectActions.notify_admin)"></toggle-switch-c>

			</div>
		</div>
	</div>
</ng-container>
